export default function authHeader() {
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.accessToken) {
        return { Authorization: 'Bearer ' + user.accessToken, 'X-Frontend-Token': "a67b066d010e43448621b72837e16333"};
    } else {
        return {'X-Frontend-Token': "a67b066d010e43448621b72837e16333"};
    }
}